import { NetworkStatus } from "@apollo/client"
import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import AppViewSheetBreadcrumb from "@/v2-backoffice-client/app/AppViewSheetBreadcrumb"
import { useInvitationViewQuery } from "@/v2-backoffice-client/invitation/view/invitation.view.query"
import InvitationViewInfo from "@/v2-backoffice-client/invitation/view/InvitationViewInfo"
import InvitationViewToolbar from "@/v2-backoffice-client/invitation/view/InvitationViewToolbar"
import InvitationViewActivityLog from "@/v2-backoffice-client/invitation/view/InvitationViewActivityLog"
import { useAppViewSheetOpener } from "@/v2-backoffice-client/app/app.utils"

// Activity log statuses trickle in from SendGrid webhooks over time
// (delivered / opened / clicked can each land minutes apart), so the
// sheet polls while it's open rather than requiring the operator to
// close and reopen it to see the latest status.
const ACTIVITY_LOG_POLL_INTERVAL_MS = 5_000

function InvitationViewSheet() {
  const { id } = useAppViewSheetOpener()
  const invitationId = Number(id)

  const { data, loading, error, networkStatus, refetch } =
    useInvitationViewQuery({
      skip: !invitationId,
      variables: {
        id: invitationId!,
      },
      pollInterval: ACTIVITY_LOG_POLL_INTERVAL_MS,
      notifyOnNetworkStatusChange: true,
    })

  const invitation = data?.getInvitationById

  // `loading` flips true on every poll tick too (since
  // notifyOnNetworkStatusChange is on), which would otherwise flash
  // the title/info skeletons every 5s. Gate it to the initial fetch
  // (no cached data yet) and drive the refresh button's spinner off
  // networkStatus instead.
  const isInitialLoading = loading && !invitation
  const isRefreshing =
    networkStatus === NetworkStatus.refetch ||
    networkStatus === NetworkStatus.poll

  return (
    <>
      <ViewSheet.Header>
        <AppViewSheetBreadcrumb />
        <ViewSheet.Title isLoading={isInitialLoading}>
          {invitation?.Email}
        </ViewSheet.Title>
      </ViewSheet.Header>

      <ViewSheet.HeaderRow>
        <InvitationViewInfo
          invitation={invitation}
          isLoading={isInitialLoading}
          error={error}
        />
        <InvitationViewToolbar invitation={invitation} />
      </ViewSheet.HeaderRow>

      <InvitationViewActivityLog
        logs={invitation?.Logs}
        isRefreshing={isRefreshing}
        onRefresh={() => refetch()}
      />
    </>
  )
}

export default InvitationViewSheet
